import React, { useState } from 'react';

import InfiniteScroll from 'react-infinite-scroll-component';
import Masonry from 'react-masonry-css';

import { MEDIUM, LARGE } from '../../helpers/hooks/useScreenWidth';
import { Post } from '../PostsViewer/types/Post';
import { SinglePostListItem } from '../PostsViewer/components/SinglePostListItem/SinglePostListItem';
import { Instagram as PostItemLoader } from 'react-content-loader';
import { AppDownloadModal } from '../AppDownloadModal/AppDownloadModal';

interface IProps {
  posts: Post[];
  fetchMore: () => Promise<unknown>; // The result is not used, but it must be a promise so that InfiteScroll doesn't keep requesting more loads.
  hasMore: boolean;
  breakpoints?: { [key: string]: number; default: number };
  isLoading?: boolean;
  appDownloadModalHeader?: string;
  appDownloadModalText?: string;
}

const DEFAULT_BREAKPOINTS = {
  default: 3,
  [LARGE]: 2,
  [MEDIUM]: 1,
};

export const PostsMasonry = ({
  posts,
  fetchMore,
  hasMore,
  breakpoints = DEFAULT_BREAKPOINTS,
  isLoading,
  appDownloadModalHeader,
  appDownloadModalText,
}: IProps) => {
  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);
  return (
    <>
      {isLoading ? (
        <Masonry
          breakpointCols={breakpoints}
          className="flex w-auto gap-4"
          columnClassName="flex flex-col gap-4"
        >
          <PostItemLoader uniqueKey="PostsMasonry-loader-1" />
          <PostItemLoader uniqueKey="PostsMasonry-loader-2" />
          <PostItemLoader uniqueKey="PostsMasonry-loader-3" />
        </Masonry>
      ) : (
        <InfiniteScroll
          dataLength={posts.length}
          loader={<>Loading...</>}
          next={fetchMore}
          hasMore={hasMore}
        >
          <Masonry
            breakpointCols={breakpoints}
            className="flex w-auto gap-4"
            columnClassName="flex flex-col gap-4"
          >
            {posts.map(post => (
              <SinglePostListItem
                className="border-lake-fog bg-sea-foam rounded-lg border-2"
                key={`post-${post._id}`}
                post={post}
                onNotLoggedIn={() => {
                  setIsAppDownloadModalOpen(true);
                }}
              />
            ))}
          </Masonry>
        </InfiniteScroll>
      )}
      <AppDownloadModal
        appDownloadSource="PostsMasonry"
        modalHeader={appDownloadModalHeader ?? undefined}
        modalText={appDownloadModalText ?? undefined}
        showTextOnMobile
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
      />
    </>
  );
};
